import { createContext, useContext, useState, useCallback, ReactNode, lazy, Suspense } from "react";

// Loaded on demand: the questionnaire dialog (and its form logic) only
// downloads once a visitor actually opens it.
const MortgageQuestionnaire = lazy(() => import("./MortgageQuestionnaire"));

interface QuestionnaireContextValue {
  openQuestionnaire: () => void;
}

const QuestionnaireContext = createContext<QuestionnaireContextValue | null>(null);

export const useQuestionnaire = () => {
  const ctx = useContext(QuestionnaireContext);
  if (!ctx) throw new Error("useQuestionnaire must be used within QuestionnaireProvider");
  return ctx;
};

export const QuestionnaireProvider = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);
  const openQuestionnaire = useCallback(() => {
    setMounted(true);
    setOpen(true);
  }, []);

  return (
    <QuestionnaireContext.Provider value={{ openQuestionnaire }}>
      {children}
      {mounted && (
        <Suspense fallback={null}>
          <MortgageQuestionnaire open={open} onClose={() => setOpen(false)} />
        </Suspense>
      )}
    </QuestionnaireContext.Provider>
  );
};

